module.exports = __webpack_public_path__ + "media/about/AboutUs-Hero-8eb34f8a.jpg";